import styled from 'styled-components';

export const PartnerLogoInner = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
`;
